import { render, staticRenderFns } from "./deliveryreport.vue?vue&type=template&id=a5ea737c&scoped=true&"
import script from "./deliveryreport.vue?vue&type=script&lang=js&"
export * from "./deliveryreport.vue?vue&type=script&lang=js&"
import style0 from "./deliveryreport.vue?vue&type=style&index=0&id=a5ea737c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ea737c",
  null
  
)

export default component.exports